module.exports = __webpack_public_path__ + "static/media/banner@768.c8fa21bb.png";